import { render, staticRenderFns } from "./Reportes-bancos-getnet.vue?vue&type=template&id=36f707b6&scoped=true&"
import script from "./Reportes-bancos-getnet.vue?vue&type=script&lang=js&"
export * from "./Reportes-bancos-getnet.vue?vue&type=script&lang=js&"
import style0 from "./Reportes-bancos-getnet.vue?vue&type=style&index=0&id=36f707b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f707b6",
  null
  
)

export default component.exports